// extracted by mini-css-extract-plugin
export var link = "_v8-0";